import { DEFAULT_FEATURE_FLAG_SUPPORTED_TARGET_TYPES } from './feature-flags.constants';
import {
  FEATURE_FLAG_DEFINITIONS,
  type FeatureFlagName,
} from './feature-flags';
import type { FeatureFlagRuleTargetType } from './feature-flags.schema';

export const UNSUPPORTED_TARGETING_RULE_MESSAGE =
  'One or more targeting rules use a target type this flag does not support.';

export const resolveSupportedTargetTypesForFlag = ({
  flagKey,
  supportedTargetTypes,
}: {
  flagKey: FeatureFlagName;
  supportedTargetTypes?: readonly FeatureFlagRuleTargetType[] | null;
}): readonly FeatureFlagRuleTargetType[] => {
  if (supportedTargetTypes && supportedTargetTypes.length > 0) {
    return supportedTargetTypes;
  }

  const definition = FEATURE_FLAG_DEFINITIONS.find(
    (entry) => entry.name === flagKey,
  );

  return (
    definition?.supportedTargetTypes ??
    DEFAULT_FEATURE_FLAG_SUPPORTED_TARGET_TYPES
  );
};

export const supportsTargetType = ({
  supportedTargetTypes,
  targetType,
}: {
  supportedTargetTypes: readonly FeatureFlagRuleTargetType[];
  targetType: FeatureFlagRuleTargetType;
}): boolean => supportedTargetTypes.includes(targetType);

export const hasUnsupportedTargetingRules = ({
  supportedTargetTypes,
  rules,
}: {
  supportedTargetTypes: readonly FeatureFlagRuleTargetType[];
  rules?: ReadonlyArray<{ targetType: FeatureFlagRuleTargetType | string }>;
}): boolean =>
  rules?.some(
    (rule) =>
      !supportsTargetType({
        supportedTargetTypes,
        targetType: rule.targetType as FeatureFlagRuleTargetType,
      }),
  ) ?? false;
